export default __webpack_public_path__ + "static/media/customer-support-icon.1e41af49.png";